
import { Language, TranslationKeys } from '@/types/translations';
import enTranslations from './en';
import arTranslations from './ar';

export const translations: Record<Language, TranslationKeys> = {
  en: enTranslations,
  ar: arTranslations,
};
